import React from 'react';
import { Fade } from 'react-awesome-reveal';
import { FaEnvelope, FaLinkedin, FaGithub } from 'react-icons/fa';

const ContactPage = () => {
    const contactLinks = [
        {
            type: "Email",
            value: "audichyagarvit010@gmail.com",
            href: "mailto:audichyagarvit010@gmail.com",
            icon: <FaEnvelope />
        },
        {
            type: "LinkedIn",
            value: "garvit-audichya",
            href: "https://www.linkedin.com/in/garvit-audichya",
            icon: <FaLinkedin />
        },
        {
            type: "GitHub",
            value: "garvit-010",
            href: "https://github.com/garvit-010",
            icon: <FaGithub />
        }
    ];

    return (
        <div className="page-container contact-page">
            <Fade triggerOnce duration={800}>
                <h1 className="page-title">Let's Connect</h1>
                <p className="contact-intro">
                    I'm always open to discussing new opportunities, interesting projects,
                    or just having a conversation about AI and technology.
                </p>
            </Fade>

            <Fade triggerOnce duration={600} delay={100}>
                <section className="contact-links-section">
                    <div className="contact-cards">
                        {contactLinks.map((contact, index) => (
                            <a
                                key={index}
                                href={contact.href}
                                target={contact.type !== "Email" ? "_blank" : undefined}
                                rel={contact.type !== "Email" ? "noopener noreferrer" : undefined}
                                className="contact-card"
                            >
                                <span className="contact-icon">{contact.icon}</span>
                                <div className="contact-info">
                                    <h3 className="contact-type">{contact.type}</h3>
                                    <p className="contact-value">{contact.value}</p>
                                </div>
                            </a>
                        ))}
                    </div>
                </section>
            </Fade>

            <Fade triggerOnce duration={600} delay={300}>
                <section className="cta-section">
                    <p className="cta-text">Have a project in mind or want to collaborate?</p>
                    <a href="mailto:audichyagarvit010@gmail.com" className="cta-button">
                        Get In Touch
                    </a>
                </section>
            </Fade>
        </div>
    );
};

export default ContactPage;
